const content = {
  title: "Reported Speech (Statements, Questions & Commands)",
  explanation: `
At B2 level, reported speech is used to transmit statements, questions, and instructions accurately in a new context.
Example: "I am busy" becomes She said that she was busy.

Good reporting requires coordinated shifts in tense, pronouns, reference time, and place.
Example: "I will come tomorrow" becomes He said he would come the next day.

Backshifting is common with past reporting verbs, but not always required when facts remain true.
Example: She said that water boils at 100 degrees.

Mastery here is meaning-based, not mechanical: choose forms that preserve intention and clarity.
Example: "Close the window" becomes The teacher told us to close the window.
  `,
  rules: [
    "Statements: said (that) + clause",
    "Questions: asked + if / whether / wh-word (statement word order)",
    "Commands and requests: told / asked + object + to-infinitive",
    "Backshifting usually happens when the reporting verb is in the past",
    "Will → Would, Can → Could, May → Might",
    "No backshifting if the fact is still true or timeless",
    "Time and place words may change: today → that day, here → there, now → then"
  ],
  examples: [
    "She said, 'I am tired.' → She said that she was tired.",
    "He asked, 'Where do you live?' → He asked where I lived.",
    "They asked, 'Are you coming?' → They asked if I was coming.",
    "The teacher said, 'Be quiet.' → The teacher told us to be quiet.",
    "She said, 'The earth is round.' → She said that the earth is round.",
    "He said, 'I can help you.' → He said that he could help me."
  ]
};

export default content;


